import { render, staticRenderFns } from "./BlocoSituacaoTerritorio.vue?vue&type=template&id=88648842&scoped=true&lang=pug"
import script from "./BlocoSituacaoTerritorio.vue?vue&type=script&lang=js"
export * from "./BlocoSituacaoTerritorio.vue?vue&type=script&lang=js"
import style0 from "./BlocoSituacaoTerritorio.vue?vue&type=style&index=0&id=88648842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88648842",
  null
  
)

export default component.exports